class ScrollToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.addEventListener('scroll', this.toggleVisibility.bind(this));
    this.addEventListener('click', this.scrollToTop.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.toggleVisibility.bind(this));
    this.removeEventListener('click', this.scrollToTop.bind(this));
  }

  toggleVisibility() {
    if (window.scrollY > 300) {
      this.style.display = 'block';
    } else {
      this.style.display = 'none';
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('scroll-to-top', ScrollToTop);